<div class="bg-forground rounded-lg px-4 py-[4px]  sm:py-[14px] mb-4">
    <div class="flex flex-col items-center sm:flex-row sm:justify-between">
        <div class="">
            <p class="text-[#6A6A6A]"><Span class="font-bold">DRP</Span> © {{ currentYear }} All Rights Reserved | Version 1.0.4</p>
        </div>
        <div class="">
            <p class="text-[#6A6A6A]">Powered by 
                <a href="https://www.purple.lk" class="font-bold">Purple Software</a>
              </p>
        </div>
    </div>
</div>
